//System constants

export const OPERATING_MODE = {
    "MODE_NONE": "None",                  //!< Dummy value to avoid using zero enumerated type
    "MODE_ENABLED": "Enabled",               //!< Inputs and outputs in are enabled
    "MODE_INPUT_DISABLED": "Input disabled",        //!< Only the inputs are disabled
    "MODE_OUTPUT_DISABLED": "Output disabled",       //!< Only the outputs are disabled
    "MODE_BOTH_DISABLED": "Disabled",         //!< Both input and output are disabled
    "MODE_TEST_INPUT": "Test input",            //!< Sets up a zone in test mode without sounder operation
    "MODE_TEST_INPUT_OUTPUT": "Test input/output"
}

import ev_img_url_fault from "img/events/fault.png";
import ev_img_url_fire from "img/events/fire.png";
import ev_img_url_service from "img/events/service.png";
import ev_img_url_system from "img/events/system.png";
import ev_img_url_technical from "img/events/technical.png";

const img_map = {
    "fault": ev_img_url_fault,
    "fire": ev_img_url_fire,
    "service": ev_img_url_service,
    "system": ev_img_url_system,
    "technical": ev_img_url_technical,
};
export function getEventIcon(category) {
    if(category in img_map)
    {
        return img_map[category];
    }
    else{
        return ev_img_url_technical;
    }
}

import { default as MULTILOOP_MODULE_NAMES } from "conf/multiloopModuleNames.json";
// export { default as MULTILOOP_MODULE_NAMES } from "conf/multiloopModuleNames.json";


import { default as MRK2_MODULE_DATA } from "conf/deviceType.json";
// export { default as MRK2_MODULE_DATA } from "conf/deviceType.json";
export { MRK2_MODULE_DATA, MULTILOOP_MODULE_NAMES };

export const MULTILOOP_RS232_BAUD_RATE = {
    "BAUD_1200": "1200",
    "BAUD_2400": "2400",
    "BAUD_4800": "4800",
    "BAUD_9600": "9600",
    "BAUD_19200": "19200",
    "BAUD_38400": "38400",
    "BAUD_57600": "57600",
    "BAUD_115200": "115200" 
};

export const MULTILOOP_OPERATING_MODE_DEVICE = [
    "MODE_ENABLED",
    "MODE_BOTH_DISABLED"
]


export function lookupDeviceName(type)
{
    // eslint-disable-next-line no-undef
    const mrk2 = MRK2_MODULE_DATA.find(d => d.id == type);
    if(mrk2)
    {
        return mrk2.name;
    }
    // eslint-disable-next-line no-undef
    return MULTILOOP_MODULE_NAMES[type];
}